export const pages = {
    LANDING: 'landing',
    HOME: 'home',
    LOGIN: 'login',
    REGISTER: 'register',
    TRIPS: 'trips',
    TRIP: 'trip',
    TRAVELERS: 'travelers',
    DESTINATIONS: 'destinations',
    EXPERIENCES: 'experiences',
    TRIP_FORM: 'tripForm',
    MY_TRIPS: 'myTrips',
    GLOBAL: 'global',
}